import React from "react";
import { Alert } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next"; 

function AlertInfoViews({ text }) {
    const { t } = useTranslation();
    return (
        <Box py={2}>
            <Alert severity="info">{t(text)}</Alert>
        </Box>
    );
}

export default AlertInfoViews;
